
import { Link } from 'react-router-dom';

export default function AboutHero() {
  return (
    <header className="relative min-h-[85vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fb9ce18e3fa7d528145fd5cd7e06b852.jpg"
          alt="Daliah Secret Brand Story"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="max-w-2xl">
          <p className="text-[#A5D6A7] text-sm tracking-[0.3em] mb-4 font-medium">
            OUR STORY
          </p>
          <h1 className="text-6xl font-serif text-white mb-6 leading-tight">
            The Heart Behind <br />
            <span className="text-[#A5D6A7]">Daliah Secret</span>
          </h1>
          <p className="text-white/85 text-lg font-light leading-relaxed mb-10 max-w-xl">
            Born from a passion for nature&apos;s finest essences, we craft luxury perfumes and hair oils 
            that celebrate authenticity, beauty, and the art of self-expression.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/products"
              className="inline-flex items-center gap-3 px-7 py-3.5 rounded-full bg-[#2E7D32] text-white font-medium hover:bg-[#1B5E20] transition-all duration-300 cursor-pointer whitespace-nowrap text-sm tracking-wide"
            >
              EXPLORE COLLECTION
              <i className="ri-arrow-right-line"></i>
            </Link>
            <a
              href="#our-story"
              className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors cursor-pointer text-sm tracking-wide"
            >
              <span className="w-10 h-10 rounded-full border border-white/40 flex items-center justify-center">
                <i className="ri-arrow-down-line"></i>
              </span>
              Read Our Story
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
